var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewNotesSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.99 6.02011C22.01 6.26011 21.99 6.5101 21.93 6.7601L18.56 20.2901C18.32 21.3001 17.42 22.0001 16.38 22.0001H3.23998C1.72998 22.0001 0.66 20.5201 1.1 19.0701L5.30999 5.54007C5.59999 4.60007 6.47 3.96011 7.45 3.96011H19.75C20.71 3.96011 21.49 4.53011 21.82 5.33011C21.92 5.54011 21.97 5.78011 21.99 6.02011Z",
    fill: "#FFA800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.99 19.62C23.09 20.91 22.07 22 20.78 22H16.38C17.42 22 18.32 21.3 18.56 20.29L21.93 6.76001C21.99 6.51001 22.01 6.26002 21.99 6.02002L22 6L22.99 19.62Z",
    fill: "#FFA800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68001 7.13005C9.62001 7.13005 9.56002 7.12004 9.50002 7.11004C9.10002 7.01004 8.85003 6.61006 8.95003 6.20006L9.99001 1.88006C10.09 1.48006 10.49 1.24007 10.9 1.33007C11.3 1.43007 11.55 1.83004 11.45 2.24004L10.41 6.56005C10.33 6.90005 10.02 7.13005 9.68001 7.13005Z",
    fill: "#FFA800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3799 7.14005C16.3299 7.14005 16.2699 7.14003 16.2199 7.12003C15.8199 7.03003 15.56 6.63002 15.64 6.23002L16.5799 1.89005C16.6699 1.48005 17.0699 1.23004 17.4699 1.31004C17.8699 1.40004 18.1299 1.80005 18.0499 2.20005L17.1099 6.54002C17.0399 6.90002 16.7299 7.14005 16.3799 7.14005Z",
    fill: "#FFA800"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6999 12.75H7.69995C7.28995 12.75 6.94995 12.41 6.94995 12C6.94995 11.59 7.28995 11.25 7.69995 11.25H15.6999C16.1099 11.25 16.4499 11.59 16.4499 12C16.4499 12.41 16.1099 12.75 15.6999 12.75Z",
    fill: "#FFA800"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6999 16.75H6.69995C6.28995 16.75 5.94995 16.41 5.94995 16C5.94995 15.59 6.28995 15.25 6.69995 15.25H14.6999C15.1099 15.25 15.4499 15.59 15.4499 16C15.4499 16.41 15.1099 16.75 14.6999 16.75Z",
    fill: "#FFA800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNotesSectionIcon);
export default __webpack_public_path__ + "90ec72af1b82d4b80256689a75d96e97.svg";
export { ForwardRef as ReactComponent };